import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';


export enum PlaySetIconVariant {
  PLAY1 = 'play1',
  PLAY2 = 'play2',
  STOP = 'stop',
  END = 'end',
  BUBBLE_CHAT_PLAY = 'bubble_chat_play',
}

interface IPlaySetIconProps extends IConDefaultType {
  variant?: PlaySetIconVariant;
}

function PlaySetIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = PlaySetIconVariant.PLAY1,
}: IPlaySetIconProps) {
  const fill = color || EColorMap.gray_0;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === PlaySetIconVariant.PLAY1 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3017 9.07833C10.4883 8.9717 10.7173 8.97408 10.9016 9.08457L15.2089 11.6669C15.3889 11.7748 15.4994 11.9698 15.5 12.1805C15.5006 12.3913 15.3913 12.5869 15.212 12.6959L10.9047 15.3136C10.7205 15.4255 10.4907 15.4289 10.3033 15.3226C10.1159 15.2162 10 15.0165 10 14.8V9.6C10 9.38416 10.1152 9.18496 10.3017 9.07833Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === PlaySetIconVariant.PLAY2 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill="#D8D8D8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3017 9.07833C10.4883 8.9717 10.7173 8.97408 10.9016 9.08457L15.2089 11.6669C15.3889 11.7748 15.4994 11.9698 15.5 12.1805C15.5006 12.3913 15.3913 12.5869 15.212 12.6959L10.9047 15.3136C10.7205 15.4255 10.4907 15.4289 10.3033 15.3226C10.1159 15.2162 10 15.0165 10 14.8V9.6C10 9.38416 10.1152 9.18496 10.3017 9.07833Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === PlaySetIconVariant.BUBBLE_CHAT_PLAY && (
        <svg viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.1665 2.25L15.8332 9L4.1665 15.75V2.25Z"
            fill="white"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {variant === PlaySetIconVariant.STOP && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 8C10.5523 8 11 8.44772 11 9V15C11 15.5523 10.5523 16 10 16C9.44772 16 9 15.5523 9 15V9C9 8.44772 9.44772 8 10 8Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 8C14.5523 8 15 8.44772 15 9V15C15 15.5523 14.5523 16 14 16C13.4477 16 13 15.5523 13 15V9C13 8.44772 13.4477 8 14 8Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === PlaySetIconVariant.END && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 8.70001C15.5523 8.70001 16 9.14773 16 9.70001V14.3C16 14.8523 15.5523 15.3 15 15.3C14.4477 15.3 14 14.8523 14 14.3V9.70001C14 9.14773 14.4477 8.70001 15 8.70001Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.27431 8.78079C8.44387 8.67083 8.65211 8.67329 8.81965 8.78722L12.7354 11.4502C12.899 11.5615 12.9994 11.7626 13 11.9799C13.0006 12.1973 12.9012 12.399 12.7382 12.5114L8.82244 15.2109C8.65501 15.3263 8.44608 15.3299 8.27572 15.2201C8.10537 15.1104 8 14.9045 8 14.6813V9.31876C8 9.09618 8.10475 8.89075 8.27431 8.78079Z"
            fill={fill}
          />
        </svg>
      )}
    </i>
  );
}

export default PlaySetIcon;
